import { apiResponseSchema, idNameSchema, type ApiResponse, type IdName } from '@/api';
import { z } from 'zod';

// Re-export common types for backward compatibility
export { idNameSchema };
export type { ApiResponse, IdName };

// ============ ENTITY SCHEMAS ============

export const vesselJobCrewDutyRankInfoSchema = z.object({
  Id: z.string().optional(),
  DutyRankName: z.string().optional()
});

export type VesselJobCrewDutyRankInfo = z.infer<typeof vesselJobCrewDutyRankInfoSchema>;

export const vesselJobCrewDutyRankCoreSchema = z.object({
  DutyRankId: z.string().optional(),
  Id: z.string().optional(),
  VesselJobId: z.string().optional()
});

export type VesselJobCrewDutyRankCore = z.infer<typeof vesselJobCrewDutyRankCoreSchema>;

export const vesselJobCrewDutyRankSchema = vesselJobCrewDutyRankCoreSchema.extend({
  DutyRankName: z.string().optional()
});

export type VesselJobCrewDutyRank = z.infer<typeof vesselJobCrewDutyRankSchema>;

export const vesselJobCrewDutyRankExSchema = vesselJobCrewDutyRankCoreSchema
  .omit({
    DutyRankId: true,
    VesselJobId: true
  })
  .extend({
    DutyRank: idNameSchema.optional(),
    VesselJob: z.object({ Id: z.string().optional() }).optional()
  });

export type VesselJobCrewDutyRankEx = z.infer<typeof vesselJobCrewDutyRankExSchema>;

// ============ ARRAY SCHEMAS ============

export const vesselJobCrewDutyRankCoreArraySchema = z.array(vesselJobCrewDutyRankCoreSchema);
export const vesselJobCrewDutyRankArraySchema = z.array(vesselJobCrewDutyRankSchema);
export const vesselJobCrewDutyRankExArraySchema = z.array(vesselJobCrewDutyRankExSchema);
export const vesselJobCrewDutyRankInfoArraySchema = z.array(vesselJobCrewDutyRankInfoSchema);

// ============ API RESPONSE SCHEMAS ============

export const vesselJobCrewDutyRankCoreApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankCoreSchema);
export const vesselJobCrewDutyRankApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankSchema);
export const vesselJobCrewDutyRankExApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankExSchema);
export const vesselJobCrewDutyRankInfoApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankInfoSchema);

export const vesselJobCrewDutyRankCoreArrayApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankCoreArraySchema);
export const vesselJobCrewDutyRankArrayApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankArraySchema);
export const vesselJobCrewDutyRankExArrayApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankExArraySchema);
export const vesselJobCrewDutyRankInfoArrayApiResponseSchema = apiResponseSchema(vesselJobCrewDutyRankInfoArraySchema);
